import { render, staticRenderFns } from "./CategoryFooter.vue?vue&type=template&id=4c33bf22&scoped=true"
import script from "./CategoryFooter.vue?vue&type=script&lang=js"
export * from "./CategoryFooter.vue?vue&type=script&lang=js"
import style0 from "./CategoryFooter.vue?vue&type=style&index=0&id=4c33bf22&prod&lang=scss"
import style1 from "./CategoryFooter.vue?vue&type=style&index=1&id=4c33bf22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c33bf22",
  null
  
)

export default component.exports